import { render, staticRenderFns } from "./CardEtatTicket.vue?vue&type=template&id=31b585c9&scoped=true"
import script from "./CardEtatTicket.vue?vue&type=script&lang=js"
export * from "./CardEtatTicket.vue?vue&type=script&lang=js"
import style0 from "./CardEtatTicket.vue?vue&type=style&index=0&id=31b585c9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b585c9",
  null
  
)

export default component.exports